const CreateRegion = async (data) => {
  let response = await fetch(`${process.env.REACT_APP_API_URL}/Regions/AddRegion`, {
    method: "POST",
    body: JSON.stringify({
      name: data.regionName,
      status: 1,
      minQty: data.minQty,
    }),
    headers: { "Content-Type": "application/json" },
  }).catch((err) => {
    console.log(err);
  });

  return response.status === 200;
};

export default CreateRegion;
